const skeletonLoaderModule = angular.module('skeletonLoader', []);

const skeletonLoader = require('./skeleton-loader.component');
skeletonLoaderModule.component({
  skeletonLoader
});

module.exports = skeletonLoaderModule;